<div class="bg-primary d-flex align-items-center justify-content-center position-relative p-2 text-white">
    <span>Toolbox {{ toolbox?.begindate | date: 'EEEE d MMMM' }}</span>
    <button class="position-absolute end-0 text-white" [disabled]="!showClose" (click)="close()" mat-icon-button>
        @if (showClose) {
            <mat-icon class="fas fa-times"></mat-icon>
        }
        @if (!showClose) {
            <span>{{ secToClose }}</span>
        }
    </button>
</div>
@if (!pdfUrl) {
    <div class="d-flex align-items-center justify-content-center flex-fill">
        <span>Er is momenteel geen toolbox</span>
    </div>
}
@if (pdfUrl) {
    <div class="pdf-viewer flex-fill">
        <app-image-modal [data]="pdfData" [showCloseButton]="false"></app-image-modal>
    </div>
}
@if (questions?.length > 0) {
    <div class="toolbox-footer">
        <button (click)="openQuiz()" mat-raised-button color="primary">Open quiz</button>
    </div>
}
